import { commitMutation, graphql } from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import { trackEvent } from '../../tracking/amplitude/TrackingV2';
import { omit } from 'lodash';
const mutation = graphql `
	mutation DeleteDeliverableMutation($input: DeleteDeliverableInput!) {
		deleteDeliverable(input: $input) {
			deletedDeliverableId
		}
	}
`;
function getConfigs(input) {
    return [
        {
            type: 'RANGE_DELETE',
            parentID: input.projectId,
            connectionKeys: [
                {
                    key: 'Project_deliverables',
                },
            ],
            pathToConnection: ['project', 'deliverables'],
            deletedIDFieldName: 'deletedDeliverableId',
        },
    ];
}
function getOptimisticResponse(input) {
    return {
        deleteDeliverable: {
            deletedDeliverableId: input.id,
        },
    };
}
function commit(environment, input, onSuccess, onError) {
    trackEvent('Deliverable', 'Deleted', input);
    const cleanedInput = omit(input, ['projectId']);
    const variables = {
        input: Object.assign({ csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId() }, cleanedInput),
    };
    return commitMutation(environment, {
        mutation,
        variables,
        configs: getConfigs(input),
        optimisticResponse: getOptimisticResponse(input),
        onCompleted: onSuccess,
        onError: onError,
    });
}
export default { commit };
